import { PDPPageReviewSection } from './PDPPageReviewSection';
import HomePageReviewSection from './HomePageReviewSection';
import GGUCampaignSection from './GGUCampaignSection';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentRegistry = new Map<string, React.ComponentType<any>>([
  ['HomePageReviewSection', HomePageReviewSection],
  ['PDPPageReviewSection', PDPPageReviewSection],
  ['GGUSection', GGUCampaignSection],
]);
